import type { EnumObjectToUnion } from "@/utils/enum";

export const TAB_FILTER = {
  INTEGRATIONS: "INTEGRATIONS",
  CUSTOM_APPS: "CUSTOM_APPS",
  DEACTIVATED: "DEACTIVATED",
  ALL: "ALL",
} as const;

export type TabFilter = EnumObjectToUnion<typeof TAB_FILTER>;
